<div id="sliderFrame">
    <div id="slider">
        <!-- <a href="http://www.menucool.com/javascript-image-slider" target="_blank">
            <img src="images/image-slider-1.jpg" alt="Welcome to Menucool.com" />
        </a> -->
        <img src="/assets/img/showcase/5.jpg" />
        <img src="/assets/img/showcase/6.jpeg"  />
        <img src="/assets/img/showcase/1.jpg"  />
        <img src="/assets/img/showcase/8.jpg" />
        <img src="/assets/img/showcase/7.jpeg" />
        <img src="/assets/img/showcase/3.jpg"  />
        <img src="/assets/img/showcase/4.jpg"  />
       
    </div>
</div>